import apiClient from './apiClient';

/**
 * Service for favorites-related API requests
 */
const favoritesService = {
  /**
   * Get all favorite properties for the current user
   * @return {Promise} - API response
   */
  getFavorites: () => {
    return apiClient.get('/favorites');
  },
  
  /**
   * Add a property to favorites for the current user
   * @param {string} propertyId - Property ID to add
   * @param {object} notes - Optional notes for the property
   * @return {Promise} - API response
   */
  addFavorite: (propertyId, notes = '') => {
    return apiClient.post('/favorites', { propertyId, notes });
  },
  
  /**
   * Remove a property from favorites for the current user
   * @param {string} propertyId - Property ID to remove
   * @return {Promise} - API response
   */
  removeFavorite: (propertyId) => {
    return apiClient.delete(`/favorites/${propertyId}`);
  },
  
  /**
   * Update notes for a favorite property
   * @param {string} propertyId - Property ID
   * @param {string} notes - Updated notes
   * @return {Promise} - API response
   */
  updateNotes: (propertyId, notes) => {
    return apiClient.patch(`/favorites/${propertyId}`, { notes });
  },
  
  /**
   * Check if a property is favorited by the current user
   * @param {string} propertyId - Property ID to check
   * @return {Promise} - API response
   */
  isFavorited: (propertyId) => {
    return apiClient.get(`/favorites/check/${propertyId}`);
  },

  /**
   * Clear all favorites for the current user
   * @return {Promise} - API response
   */
  clearFavorites: () => {
    return apiClient.delete('/favorites');
  }
};

export default favoritesService; 